import React, { useState } from "react";
import type { Notification } from "../types";
import { LeadMemberAssign } from "./notification-types/lead-member-assign";
import { TaskCreated } from "./notification-types/task-created";
import { OpportunityCreated } from "./notification-types/opportunity-created";
import { OpportunityAssign } from "./notification-types/opportunity-assign";
import { TaskAssign } from "./notification-types/task-assign";
import { LeadSelfAssign } from "./notification-types/lead-self-assign";

interface NotificationItemProps {
  notification: Notification;
  tabValue: number; // 0: tasks, 1: others, 2: workspace, 3: all
  updateNotificationStatus: (params: {
    notification?: any;
    redirect?: boolean;
    otherSwitch?: boolean;
  }) => void;
  setNotification_list?: (updater: any) => void;
  showCheckbox?: boolean;
  handleSelect?: (notification: any) => (event: React.MouseEvent) => void;
  cutMessage?: (message: string, charLimit: number) => string;
  hideHeaderElements?: boolean;
  handleCheckDelete?: (id: any) => void;
  handleMarkAllAsRead?: () => void;
  readStatus: boolean;
}

export const NotificationItem: React.FC<NotificationItemProps> = ({
  notification,
  updateNotificationStatus,
}) => {
  if (notification.notification_type === "lead_member_assign") {
    return (
      <LeadMemberAssign
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
      />
    );
  }

  if (notification.notification_type === "task_created") {
    return (
      <TaskCreated
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
      />
    );
  }

  if (notification.notification_type === "pipeline_created") {
    return (
      <OpportunityCreated
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
      />
    );
  }

  if (notification.notification_type === "pipeline_assign") {
    return (
      <OpportunityAssign
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
      />
    );
  }

  if (notification.notification_type === "task_assign") {
    return (
      <TaskAssign
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
      />
    );
  }

  if (
    notification.notification_type === "leads_claim" ||
    notification.notification_type === "lead_self_assign"
  ) {
    return (
      <LeadSelfAssign
        notification={notification}
        updateNotificationStatus={updateNotificationStatus}
      />
    );
  }

  return <div>NotificationItem</div>;
};
